import React from "react";
import style from "./DownloadApp.module.css";
interface DownloadAppProps {
  className?: string;
}
const DownloadApp = ({ className }: DownloadAppProps) => {
  return (
    <div className={`${style.app} ${className}`}>
      <div className={style.inner}>
        <div className={style.title}>
          <span>دانلود اپلیکیشن بانی‌مد از:</span>
        </div>
        <div className={style.logoItems}>
          <a
            href="https://cafebazaar.ir/app/com.banimode.app/?l=en"
            target="_blank"
            rel="noreferrer"
            className={style.logoItem}
          >
            <img
              src={`${process.env.PUBLIC_URL}/assets/icon/cafe-bazar.png`}
              alt="bazar"
              className="w-[69px] h-[32px]"
            />
          </a>
          <span className={style.additionText}>یا</span>
          <a
            href="https://sibapp.com/applications/banimode"
            target="_blank"
            rel="noreferrer"
            className={style.logoItem}
          >
            <img
              src={`${process.env.PUBLIC_URL}/assets/icon/sib-app.png`}
              alt="sib"
              className="w-[86px] h-[24px]"
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default DownloadApp;
